import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../components/context/Auth";
import {
  // DefaultLogo,
  HomeImg,
  LogInBtnIcon,
  LogInImg,
  Spinner,
  // WalliconLogo,
} from "../components/icons/Icon";
import styles from "./Home.module.css";
import CryptoJS from "crypto-js";
import InputTag2 from "../components/updatedComponents/FormComponents/InputTag2";
import Request from "../components/updatedComponents/Login/Request";
import PinSetup from "../components/updatedComponents/Login/PinSetup";
import Pinlogin from "../components/updatedComponents/Login/Pinlogin";
import RequestPending from "../components/updatedComponents/Login/RequestPending";
import useDeviceInfo from "../components/updatedComponents/Hooks/GetdeviceId";
import fetchData from "../APIsControll/apiControll";
import { useToast } from "../components/updatedComponents/Toaster/Toaster";
import DesableLogin from "../components/updatedComponents/Login/DesableLogin";
import AdminOtpverify from "../components/updatedComponents/Login/AdminOtpverify";
import { socket, SocketConnected } from "../Socket/socket";
import { decryptData, encryptData } from "../Encryption/Encryption";
import { saveCookies } from "../Utils/Cookies";
import { CryptoEncrypt } from "../Utils/TextUtils";
import { useBranding } from "../components/context/BrandingContext";

const Home = () => {
  const navigate = useNavigate();
  const {
    setDesignation,
    setManagerId,
    setManagerName,
    setLoggedIn,
    mode,
    setWarehouse,
    startTimer,
    handleSignOut,
    managerId,
    // settingsData,
    // setSettingsData,
  } = useAuth();
  const { branding } = useBranding();
  const [devicename, setdevicename] = useState();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    error: "",
  });
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const [confirmPin, setConfirmPin] = useState(["", "", "", "", "", ""]);
  const [loginPin, setLoginpin] = useState(["", "", "", "", "", ""]);

  const [confirmOtp, setConfirmOtp] = useState(["", "", "", "", "", ""]);
  const [loginOtp, setLoginOtp] = useState(["", "", "", "", "", ""]);
  // const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    loading5: false,
  });

  const [error, setError] = useState(false);
  const [screen, setScreen] = useState(
    localStorage.getItem("loginID") ? "active" : "default",
  );
  const [name, setName] = useState("");
  const { show } = useToast();
  const { deviceId, osName } = useDeviceInfo();

  useEffect(() => {
    const undeviceId = localStorage.getItem("UnDeviceId");
    if (!undeviceId) {
      localStorage.setItem("UnDeviceId", deviceId);
    }
  }, [deviceId]);

  const getdeviceIdStatus = async () => {
    try {
      setLoading({ ...loading, loading2: true });
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID") || credentials.username,
      };
      const enPayload = encryptData(payload);
      const response = await fetchData(`managers/getdeviceIdStatus`, {
        payload: enPayload,
      });
      const res = decryptData(response.res);
      // console.log("getdeviceIdStatus payload", payload);

      // console.log("getdeviceIdStatus res", res);

      if (res?.status === "success") {
        setScreen(res?.deviceActive);
        setName(res?.name);
        setLoading({ ...loading, loading2: false });
        // getSettingsData(res?.ID);
        return;
      }
      if (res?.status === "failed") {
        setScreen("default");
        setLoading({ ...loading, loading2: false });
        return;
      } else {
        show("something wrong ", "error");
        setLoading({ ...loading, loading2: false });
        return;
      }
    } catch (error) {
      show("something wrong ", "error");
      setLoading({ ...loading, loading2: false });
    }
  };
  // ------------------------------------------------------------------------------
  // const getSettingsData = async (id) => {
  //   // console.log(id);
  //   const payload = {
  //     managerId: id,
  //   };
  //   const enPayload = encryptData(payload);
  //   try {
  //     const response = await fetchData(`managers/getSettingsData`, {
  //       payload: enPayload,
  //     });
  //     const res = decryptData(response.res);
  //     // console.log(res);
  //     if (res?.status === "success") {
  //       // console.log(res);
  //       // companyLogo: "settings/admin/1777294066437454726-PF8Y1D-750.jpg";
  //       // companyName: "";
  //       // paymentGatewayAccess: false;
  //       // projectName: "Admin Suite";
  //       // status: "success";
  //       // websiteLink: "";
  //       setSettingsData({
  //         companyLogo: res.companyLogo,
  //         companyName: res.companyName,
  //         paymentGatewayAccess: res.paymentGatewayAccess,
  //         projectName: res.projectName,
  //         websiteLink: res.paymentGatewayAccess ? res.websiteLink : "",
  //       });
  //     }
  //     if (res?.status === "failed") {
  //       // show(res?.msg, "error");
  //       localStorage.removeItem("settingsData");
  //       setSettingsData({
  //         companyLogo: "",
  //         companyName: "",
  //         paymentGatewayAccess: false,
  //         projectName: "",
  //         websiteLink: "",
  //       });
  //     }
  //   } catch (error) {
  //     show("something wrong ", "error");
  //   }
  // };
  // ------------------------------------------------------------------------------

  // request For Device
  const requestForDevice = async () => {
    try {
      setLoading({ ...loading, loading5: true });
      setLoading({ ...loading, loading2: true });
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID") || credentials.username,
        deviceName: devicename,
      };
      const result = await fetchData(`managers/requestForDevice`, {
        payload: encryptData(payload),
      });
      const res = decryptData(result.res);

      if (res?.status === "success") {
        setLoading({ ...loading, loading5: false });
        getdeviceIdStatus();
        return;
      }
      if (res?.status === "failed") {
        setLoading({ ...loading, loading5: false });
        show(res?.msg, "error");
        return;
      } else {
        show("something wrong ", "error");
        return;
      }
    } catch (error) {
      show("something wrong ", "error");
      setLoading({ ...loading, loading5: false });
    }
  };
  const logoutDevice = async () => {
    try {
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID") || credentials.username,
      };
      setLoading({ ...loading, loading4: true });
      setLoading({ ...loading, loading2: true });

      const result = await fetchData(`managers/logoutDevice`, {
        payload: encryptData(payload),
      });
      const res = decryptData(result.res);
      if (res?.status === "success") {
        setScreen("default");
        getdeviceIdStatus();
        setLoading({ ...loading, loading4: false });
        return;
      }
      if (res?.status === "failed") {
        setLoading({ ...loading, loading4: false });
        show(res?.msg);
        return;
      } else {
        show("something wrong ", "error");
        setLoading({ ...loading, loading4: false });
        return;
      }
    } catch (error) {
      show("something wrong ", "error");
      setLoading({ ...loading, loading4: false });
    }
  };

  // pinSetup
  const pinSetup = async () => {
    try {
      setLoading({ ...loading, loading2: true });
      const pinString = pin.join("");
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID") || credentials.username,
        pin: pinString,
      };
      const result = await fetchData(`managers/pinSetup`, {
        payload: encryptData(payload),
      });
      const res = decryptData(result.res);
      if (res?.status === "success") {
        setLoading({ ...loading, loading2: false });
        getdeviceIdStatus();
        return;
      }
      if (res?.status === "failed") {
        setLoading({ ...loading, loading2: false });
        show(res?.msg, "error");
        return;
      } else {
        setLoading({ ...loading, loading2: false });
        show("something wrong ", "error");
        return;
      }
    } catch (error) {
      setLoading({ ...loading, loading2: false });
      show("something wrong ", "error");
    }
  };

  // console.log("deviceId", deviceId);

  const loginWithotp = async () => {
    try {
      const pinString = loginOtp.join("");
      const payload = {
        loginId: localStorage.getItem("loginID") || credentials.username,
        deviceId: localStorage.getItem("UnDeviceId"),
        otp: pinString,
      };

      const res = await fetchData(`managers/adminotpverify`, {
        payload: encryptData(payload),
      });
      if (res?.status === "success") {
        // decrypt all auth
        const managerIdKey = decryptData(res?.user?.managerId);
        const warehouseKey = decryptData(res?.user?.warehouse);
        const NameKey = decryptData(res?.user?.name);
        const frist_designationKey = decryptData(res?.user?.designation);
        const Login_IdKey = decryptData(res?.user?.loginId);

        //  save cookies
        saveCookies("managerId", CryptoEncrypt(managerIdKey));
        saveCookies("warehouse", CryptoEncrypt(warehouseKey));

        // getSettingsData(managerIdKey);

        // encrypt auth by Crypto js
        const encryptedName = CryptoEncrypt(NameKey);
        const encryptedDesignation = CryptoEncrypt(frist_designationKey[0]);
        const encryptedDesignations = CryptoEncrypt(
          JSON.stringify(frist_designationKey),
        );
        const encryptedLoginId = CryptoEncrypt(JSON.stringify(Login_IdKey));

        // save in local and session
        localStorage.setItem("warehouse", JSON.stringify(warehouseKey));
        sessionStorage.setItem("managerId", managerIdKey);
        sessionStorage.setItem("name", encryptedName);
        sessionStorage.setItem("designation", encryptedDesignation);
        sessionStorage.setItem("designations", encryptedDesignations);
        sessionStorage.setItem("loginID", encryptedLoginId);

        setDesignation(frist_designationKey[0]);
        setManagerId(managerIdKey);
        setWarehouse(warehouseKey);
        setManagerName(NameKey);
        setLoggedIn(true);
        navigate("/dashboard");
        startTimer();
        return;
      }
      if (res?.status === "failed") {
        show(decryptData(res?.msg), "error");
        return;
      } else {
        show("something wrong", "error");
        return;
      }
    } catch (error) {
      show("something wrong", "error");
    }
  };

  const getCooldownData = () => {
    const data = JSON.parse(localStorage.getItem("pinCooldown")) || {
      attempts: 0,
      totalFails: 0,
      lockUntil: null,
      increment: 2,
    };
    return data;
  };

  const setCooldownData = (data) => {
    localStorage.setItem("pinCooldown", JSON.stringify(data));
  };

  const resetCooldownData = () => {
    localStorage.removeItem("pinCooldown");
  };

  //  login with pin
  const loginWithPin = async () => {
    const cooldown = getCooldownData();
    const now = new Date().getTime();
    if (cooldown.lockUntil && now < cooldown.lockUntil) {
      const remaining = Math.ceil((cooldown.lockUntil - now) / 1000);
      show(`Please wait ${remaining} seconds before trying again.`, "error");
      return;
    }
    try {
      setLoading({ ...loading, loading2: true });
      const pinString = loginPin.join("");
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID") || credentials.username,
        pin: pinString,
      };
      const res = await fetchData(`managers/pinLogin`, {
        payload: encryptData(payload),
      });
      if (res?.status === "success") {
        resetCooldownData();
        if (res.user) {
          // decrypt all auth
          const managerIdKey = decryptData(res?.user?.managerId);
          const warehouseKey = decryptData(res?.user?.warehouse);
          const NameKey = decryptData(res?.user?.name);
          const frist_designationKey = decryptData(res?.user?.designation);
          const Login_IdKey = decryptData(res?.user?.loginId);

          // encrypt auth by Crypto js
          const encryptedName = CryptoEncrypt(NameKey);
          const encryptedDesignation = CryptoEncrypt(frist_designationKey[0]);
          const encryptedDesignations = CryptoEncrypt(
            JSON.stringify(frist_designationKey),
          );
          const encryptedLoginId = CryptoEncrypt(Login_IdKey);

          // save cookies
          saveCookies("managerId", CryptoEncrypt(managerIdKey));
          saveCookies("warehouse", CryptoEncrypt(warehouseKey));
          // getSettingsData(managerIdKey);

          // save in local and session
          localStorage.setItem("warehouse", JSON.stringify(warehouseKey));
          localStorage.setItem("loginName", NameKey);
          sessionStorage.setItem("managerId", managerIdKey);
          sessionStorage.setItem("name", encryptedName);
          sessionStorage.setItem("designation", encryptedDesignation);
          sessionStorage.setItem("designations", encryptedDesignations);
          sessionStorage.setItem("loginID", encryptedLoginId);

          // if (frist_designationKey[0] === "paymentmanager") {
          if (frist_designationKey?.includes("paymentmanager")) {
            const encrypted_Manager_Auth = decryptData(res?.user?.managerAuth);
            const encryptedManagerAuth = CryptoEncrypt(
              JSON.stringify(encrypted_Manager_Auth),
            );
            localStorage.setItem("managerAuth", encryptedManagerAuth);
            sessionStorage.setItem("managerAuth", encryptedManagerAuth);
          }
          if (frist_designationKey?.includes("marketing")) {
            const encrypted_Marketing_Auth = decryptData(
              res?.user?.marketingManagerAuth,
            );
            const encryptedMarketingAuth = CryptoEncrypt(
              JSON.stringify(encrypted_Marketing_Auth),
            );
            localStorage.setItem(
              "marketingManagerAuth",
              encryptedMarketingAuth,
            );
            sessionStorage.setItem(
              "marketingManagerAuth",
              encryptedMarketingAuth,
            );
          }
          // ---------Order Manager Auth---------
          if (frist_designationKey?.includes("ordermanager")) {
            const encrypted_Order_Auth = decryptData(
              res?.user?.orderManagerAuth,
            );
            // console.log(encrypted_Order_Auth);

            const encryptedOrderAuth = CryptoEncrypt(
              JSON.stringify(encrypted_Order_Auth),
            );
            localStorage.setItem("orderManagerAuth", encryptedOrderAuth);
            sessionStorage.setItem("orderManagerAuth", encryptedOrderAuth);
          }

          // ---------Production Manager Auth---------
          if (frist_designationKey?.includes("productionmanager")) {
            const encrypted_productionManagerAuth = decryptData(
              res?.user?.productionManagerAuth,
            );
            // console.log(encrypted_productionManagerAuth);

            const encryptedOrderAuth = CryptoEncrypt(
              JSON.stringify(encrypted_productionManagerAuth),
            );
            localStorage.setItem("productionManagerAuth", encryptedOrderAuth);
            sessionStorage.setItem("productionManagerAuth", encryptedOrderAuth);
          }

          // save data in state
          // sessionStorage.setItem("warehouse", encryptedwarehouse);

          // save data in state
          setDesignation(frist_designationKey[0]);
          setManagerId(managerIdKey);
          setWarehouse(warehouseKey);
          setManagerName(NameKey);
          setLoggedIn(true);
          // navigate("/dashboard");
          const route = localStorage.getItem("dashboardRoute");
          navigate(route ? route : "/dashboard");
          startTimer();
        } else {
          getdeviceIdStatus();
          show(`${decryptData(res?.msg)}`, "success");
        }
        return;
      }
      if (res?.status === "failed") {
        setLoginpin(["", "", "", "", "", ""]);
        let cooldown = getCooldownData();
        cooldown.attempts += 1;
        cooldown.totalFails += 1;
        if (cooldown.attempts >= 3) {
          const now = new Date().getTime();
          const additionalTime = cooldown.increment * 60 * 1000;
          cooldown.lockUntil = now + additionalTime;
          cooldown.increment += 2;
          cooldown.attempts = 0;
        } else {
          if (cooldown.totalFails !== 5) {
            show(`${decryptData(res.msg)}`, "error");
          }
        }
        setCooldownData(cooldown);
        setLoginpin(["", "", "", "", "", ""]);

        if (cooldown.totalFails >= 5) {
          try {
            const paylod = {
              loginId: localStorage.getItem("loginID"),
              deviceId: localStorage.getItem("UnDeviceId"),
            };
            const result = await fetchData(`managers/logoutDevice`, {
              payload: encryptData(paylod),
            });
            const res = decryptData(result.res);
            if (res?.status === "success") {
              getdeviceIdStatus();
              show(`${res?.msg}`, "success");
            } else if (res?.status === "failed") {
              show(`${res?.msg}`, "error");
            } else {
              show("Something went wrong", "error");
            }
          } catch (error) {
            show("Something went wrong", "error");
          }
        }

        setLoading({ ...loading, loading2: false });
        return;
      } else {
        show("something went wrong", "error");
        setLoading({ ...loading, loading2: false });
        return;
      }
    } catch (error) {
      show("something went wrong ", "error");
      setLoading({ ...loading, loading2: false });
    }
  };

  useEffect(() => {
    if (deviceId) {
      getdeviceIdStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId]);

  const handleClick = async () => {
    setError(false);
    setLoading({ ...loading, loading1: true });
    const payload = {
      loginId: credentials.username,
      password: credentials.password,
      deviceId: localStorage.getItem("UnDeviceId"),
      devicePlatform: "web",
      deviceOS: osName,
    };
    try {
      const enPayload = encryptData(payload);
      const res = await fetchData(`managers/login`, { payload: enPayload });
      const result = decryptData(res.res);
      if (result?.status === "success") {
        localStorage.setItem("loginID", result?.loginId);
        localStorage.setItem("loginName", result?.name);
        setLoading(false);
        getdeviceIdStatus();
        setLoading({ ...loading, loading1: false });
        show(`${result?.msg}`, "success");
      } else {
        show(`${result?.msg}`, "error");
        setCredentials({ ...credentials, error: result.msg });
      }
      // setMsg(result.msg);
      setLoading(false);
    } catch (error) {}
  };

  // var designations = sessionStorage.getItem("designation");
  const getDesignation = sessionStorage.getItem("designation")
    ? sessionStorage.getItem("designation")
    : "";
  const decryptedDesignationBytes = CryptoJS.AES.decrypt(
    getDesignation,
    "secret key",
  );
  const designationss = decryptedDesignationBytes.toString(CryptoJS.enc.Utf8);
  useEffect(() => {
    if (designationss) {
      setDesignation(designationss.split(",")[0]);
    }
  }, [setDesignation, designationss]);

  useEffect(() => {
    SocketConnected({
      socketUserId: `${localStorage.getItem("UnDeviceId")}`,
      role: "manager",
      warehouseNames: [],
    });
    socket.on("getdeviceIdStatus", (getdeviceIdStatusIs) => {
      if (getdeviceIdStatusIs?.deviceActive === "disabled") {
        handleSignOut();
      }
      if (getdeviceIdStatusIs?.deviceActive === "pinsetup") {
        getdeviceIdStatus();
      }
      return;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    SocketConnected({
      socketUserId: `${localStorage.getItem("UnDeviceId")}`,
      role: "superadmin",
      managerId: managerId,
    });
    socket.on("removedevicepermission", (removedevicepermission) => {
      // console.log("removedevicepermission", removedevicepermission);

      if (
        // removedevicepermission?.managerId === String(managerId) &&
        removedevicepermission?.deviceId ===
        `${localStorage.getItem("UnDeviceId")}`
      ) {
        handleSignOut();
      }
      // if (removedevicepermission?.deviceActive === "pinsetup") {
      //   getdeviceIdStatus();
      // }
      return;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div
        className={styles.home}
        style={mode ? { backgroundColor: "#232529" } : {}}
      >
        <div
          className={styles.frame}
          style={mode ? { backgroundColor: "#2C2E33" } : {}}
        >
          <div className={styles.sub_Frame}>
            <div className={styles.home_Logo}>
              {/* <WalliconLogo /> */}
              {branding.favicon && (
                <img src={branding.favicon} alt="Company Logo" />
              )}
            </div>
            <HomeImg />
            {/* <h1 className={styles.home_wallicon_heading}>
              Wallicon Admin Suite
            </h1> */}
            <h1 className={styles.home_wallicon_heading}>{branding?.title}</h1>
          </div>
        </div>
        {loading.loading2 ? (
          <div
            className={styles.login_container}
            style={mode ? { backgroundColor: "#2C2E33" } : {}}
          >
            <div
              className={styles.login1}
              style={mode ? { backgroundColor: "#232529" } : {}}
            >
              <div>
                <div className={styles.sub_Login}>
                  <form className={styles.login_Form}>
                    <Spinner size={"100"} />
                  </form>
                  <div style={{ marginTop: "40px" }}> </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {screen === "default" && (
              <div
                className={styles.login_container}
                style={mode ? { backgroundColor: "#2C2E33" } : {}}
              >
                <div
                  className={styles.login}
                  style={mode ? { backgroundColor: "#232529" } : {}}
                >
                  <div className={styles.sub_Login}>
                    <div className={styles.login_Header}>
                      <div className={styles.login_Header_Text}>
                        <h2 style={mode ? { color: "#ffffff" } : {}}>Login</h2>
                        <p style={mode ? { color: "#9C9797" } : {}}>
                          Thank you for get back to Wallicon
                        </p>
                      </div>
                      <LogInImg />
                    </div>
                    <form
                      className={styles.login_Form}
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleClick();
                      }}
                    >
                      <InputTag2
                        labelText={"Username"}
                        placeholderType={"text"}
                        placeholderText={"Enter Username"}
                        required={true}
                        value={credentials.username}
                        maxLength={36}
                        onChange={(e) =>
                          setCredentials({
                            ...credentials,
                            username: e.target.value,
                          })
                        }
                        padding={"16px 12px 16px 12px"}
                      />
                      <InputTag2
                        labelText={"Password"}
                        placeholderType={"password"}
                        placeholderText={"Enter Password"}
                        required={true}
                        value={credentials.password}
                        maxLength={30}
                        onChange={(e) =>
                          setCredentials({
                            ...credentials,
                            password: e.target.value,
                          })
                        }
                        padding={"16px 12px 16px 12px"}
                      />
                      <button
                        type="submit"
                        disabled={loading.loading1}
                        className={styles.login_button}
                      >
                        {loading.loading1 ? (
                          <>
                            <span className={styles.spinner}></span>
                            <p>Loading...</p>
                          </>
                        ) : (
                          <>
                            <LogInBtnIcon />
                            <p>Login</p>
                          </>
                        )}
                      </button>
                    </form>

                    <Link to={"#"} style={mode ? { color: "#749AFF" } : {}}>
                      Need Help?
                    </Link>
                    {/* {msg && <div className={styles.err}>{msg}</div>} */}
                    {error && (
                      <div className={styles.err}>
                        Oops! Something went wrong. Please try again later.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {screen === "new" && (
              <Request
                handleClick={requestForDevice}
                loading={loading.loading5}
                setDeviceName={setdevicename}
              />
            )}
            {screen === "pending" && (
              <RequestPending
                handleClick={logoutDevice}
                loading={loading.loading4}
              />
            )}
            {screen === "pinsetup" && (
              <PinSetup
                confirmPin={confirmPin}
                setConfirmPin={setConfirmPin}
                setPin={setPin}
                pin={pin}
                handleClick={pinSetup}
                loading={loading.loading2}
              />
            )}
            {screen === "adminOtp" && (
              <AdminOtpverify
                confirmPin={confirmOtp}
                setConfirmPin={setConfirmOtp}
                setPin={setLoginOtp}
                pin={loginOtp}
                handleClick={loginWithotp}
                loading={loading.loading2}
              />
            )}
            {screen === "active" && (
              <Pinlogin
                confirmPin={loginPin}
                setConfirmPin={setLoginpin}
                handleClick={loginWithPin}
                loading={loading.loading2}
                name={name}
              />
            )}
            {screen === "disabled" && <DesableLogin />}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default Home;
